import AddNewPill from '../AddNewPill/AddNewPill';
import styles from '../../GlobalSearch.module.scss';
import { GlobalSearchResult } from '../../useSearchResultFetcher';

type SearchResultsGroupProps = {
    title: string;
    results: GlobalSearchResult[];
    isAddNew?: boolean;
    onSelect: (result: GlobalSearchResult, index: number) => void;
};

const SearchResultsGroup = ({ title, results, isAddNew, onSelect }: SearchResultsGroupProps) => {
    if (!Array.isArray(results) || results.length === 0) return null;

    return (
        <div>
            <h3 className={styles.SearchResultHeading}>{title}</h3>
            {results.map((result, index) => {
                const resultKey = result.orgId || `${title}-${index}`;
                return (
                    <div
                        key={resultKey}
                        onMouseDown={(e) => {
                            e.stopPropagation();
                            onSelect(result, index);
                        }}
                        onClick={(e) => e.stopPropagation()}
                        className={`${styles.SearchResultItem} ${isAddNew ? styles.SearchResultItemAddNew : ''}`}
                    >
                        {isAddNew ? <AddNewPill result={result} /> : <p className={styles.OrgName}>{result.orgName}</p>}
                        <p className={styles.WebsiteUrl}>{result.secondaryMessage || result.websiteUrl}</p>
                    </div>
                );
            })}
        </div>
    );
};

export default SearchResultsGroup;
